import type { IntlShape } from 'react-intl';
import PlaceFilled from '@alltrails/denali/icons/PlaceFilled';
import { COLOR_MAP_WAYPOINT_USER, COLOR_MAP_WAYPOINT_VERIFIED } from '@alltrails/denali/tokens';
import type { WaypointCategoryUid } from '@alltrails/types/Waypoint';
import { getWaypointCategoryConfig, WAYPOINT_CATEGORY_UIDS } from '@alltrails/waypoints/utils/waypointCategories';
import type { SvgDefinition } from '../useSvgImages';
import { createIconPinSvg, POIPinSize } from './svgMarkerComponents';

export const waypointImageNamePrefix = 'waypoint';

/** Mapbox image id — includes `waypointType` so user vs community pins register as distinct images on the same map. */
export const getWaypointImageName = (categoryUid: WaypointCategoryUid, size: POIPinSize, waypointType: 'user' | 'community') =>
  `${waypointImageNamePrefix}-${waypointType}-${categoryUid}-${size}`;

const createWaypointPinSvg = (size: POIPinSize, waypointType: 'user' | 'community') =>
  createIconPinSvg(
    `${waypointImageNamePrefix}-${waypointType}-${size}`,
    PlaceFilled,
    size,
    waypointType === 'user' ? COLOR_MAP_WAYPOINT_USER : COLOR_MAP_WAYPOINT_VERIFIED
  );

export const createCategoryWaypointPinSvg = (
  intl: IntlShape,
  categoryUid: WaypointCategoryUid,
  size: POIPinSize,
  waypointType: 'user' | 'community'
): SvgDefinition => {
  const icon = getWaypointCategoryConfig(intl, categoryUid).icon;
  return createIconPinSvg(
    getWaypointImageName(categoryUid, size, waypointType),
    icon,
    size,
    waypointType === 'user' ? COLOR_MAP_WAYPOINT_USER : COLOR_MAP_WAYPOINT_VERIFIED
  );
};

export const createAllCategoryWaypointPinSvgs = (intl: IntlShape, waypointType: 'user' | 'community'): SvgDefinition[] =>
  WAYPOINT_CATEGORY_UIDS.flatMap(uid => [
    createCategoryWaypointPinSvg(intl, uid, 'xs', waypointType),
    createCategoryWaypointPinSvg(intl, uid, 'md', waypointType)
  ]);

export default createWaypointPinSvg;
